import { defineStore } from 'pinia'
import footerQuery from '../apollo/queries/components/footer.gql'

export const useFooterStore = defineStore('footer', {
  state: () => ({
    data: {}
  }),
  getters: {
    getFooter: (state) => {
      return state.data.footers?.data[0]?.attributes
    }
  },
  actions: {
    async requestData() {
      if (Object.keys(this.data).length !== 0) return

      const { data } = await useAsyncQuery(footerQuery) // eslint-disable-line no-undef

      if (data) this.data = data
    }
  }
})
